import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

import HeroSection from '../components/HeroSection';
import LoginSection from '../components/LoginSection';
import InstructorSection, { DEFAULT_INSTRUCTORS, normalizeInstructors } from '../components/InstructorSection';
import CourseCards from '../components/CourseCard';
import ServiceGrid from '../components/ServiceGrid';
import BoardPreview from '../components/BoardPreview';
import CTASection from '../components/CTASection';

const PageWrapper = styled.div`
  width: 100%;
  background: ${({ theme }) => theme.colors.neutral[0]};
`;

function HomePage() {
  const [instructors, setInstructors] = useState(DEFAULT_INSTRUCTORS);

  useEffect(() => {
    const html = document.documentElement;
    const body = document.body;
    html.style.height = 'auto';
    html.style.overflowY = 'auto';
    body.style.height = 'auto';
    body.style.overflowY = 'auto';
    return () => {
      html.style.height = '';
      html.style.overflowY = '';
      body.style.height = '';
      body.style.overflowY = '';
    };
  }, []);

  // 등록된 강사 데이터로 교체 (실패 시 기본값 유지)
  useEffect(() => {
    fetch('/lms/instructors')
      .then((r) => r.ok ? r.json() : null)
      .then((data) => {
        if (Array.isArray(data) && data.length > 0) {
          setInstructors(normalizeInstructors(data));
        }
      })
      .catch(() => { /* keep defaults */ });
  }, []);

  return (
    <PageWrapper>
      <HeroSection />
      <LoginSection />
      <InstructorSection instructors={instructors} />
      <CourseCards />
      <ServiceGrid />
      <BoardPreview />
      <CTASection />
    </PageWrapper>
  );
}

export default HomePage;
